import React from "react";

function Loader() {
  return (
    <div
      className="ui segment"
      style={{ marginTop: 2 + "rem", paddingBottom: 5 + "rem" }}
    >
      <div className="ui active inverted dimmer">
        <div className="ui massive indeterminate text loader">
          Inhalt wird geladen...
        </div>
      </div>
      <p />
    </div>
  );
}

export default Loader;
